module.exports = __webpack_public_path__ + "img/1_ua.28b939f9.jpg";